import { AlertTriangle } from 'lucide-react';
import { Button } from '../buttons';

interface DeclineTosProps {
  callback: () => void;
  toggle?: () => void;
}

const DeclineTos = ({ callback, toggle }: DeclineTosProps) => {
  return (
    <div>
      <div className="flex justify-center flex-col items-center text-center gap-y-5">
        <div className={`mt-2 rounded-full text-gray-800 p-5 bg-yellow-100`}>
          <AlertTriangle className="size-6 text-amber-900" />
        </div>

        <h3 className="text-xl font-bold text-gray-800">
          Do you want to quit?
        </h3>
        <p className="text-base text-gray-800 ">
          To continue using our service, please accept Cube’s Terms of Service.
          If you choose to decline, you will be redirected to the login page and
          unable to proceed.
        </p>
        <div className="flex gap-4">
          <Button
            onClick={callback}
            variant="white"
            className="hover:bg-red-500 hover:text-white"
          >
            Quit
          </Button>
          <Button onClick={() => toggle!()} variant="solid">
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeclineTos;
